import ResponsiveImage from '~/components/Image/ResponsiveImage'

import HeroCopy from './HeroCopy'
import HeroFloatCards from './HeroFloatCards'
import LandingV4Nav from './LandingV4Nav'
import SectionContainer from './SectionContainer'
import StatBanner from './StatBanner'
import TestimonialsMarquee from './TestimonialsMarquee'

export default function HeroSection(): React.ReactElement {
  return (
    <section className="relative overflow-hidden bg-lavender-light">
      <div
        aria-hidden
        className="pointer-events-none absolute -right-16 -top-16 hidden h-80 w-80 rounded-full bg-purple/20 blur-3xl md:block"
      />

      <LandingV4Nav />

      <div className="relative">
        <div className="pointer-events-none absolute inset-y-0 right-0 hidden w-1/2 max-w-160 md:block">
          <ResponsiveImage
            className="h-full w-full"
            fetchPriority="high"
            height={726}
            imageClassName="h-full w-full object-cover object-left"
            loading="eager"
            quality={90}
            srcKey="landing/v4/hero-brain.png"
            width={820}
          />
          <HeroFloatCards />
        </div>

        <SectionContainer className="relative">
          <div className="relative pb-4 md:min-h-192 md:pb-0">
            <div className="relative -mx-4 -mt-14 md:hidden">
              <ResponsiveImage
                className="w-full"
                fetchPriority="high"
                height={726}
                imageClassName="w-full object-contain object-top"
                loading="eager"
                srcKey="landing/v4/hero-brain.png"
                width={820}
              />
              <div
                aria-hidden
                className="pointer-events-none absolute inset-x-0 bottom-0 h-44 bg-gradient-v4-hero-fade"
              />
            </div>

            <div className="relative z-10 -mt-24 md:mt-0 md:w-1/2 md:pt-28">
              <HeroCopy />
            </div>
          </div>
        </SectionContainer>
      </div>

      <SectionContainer>
        <StatBanner />
      </SectionContainer>

      <TestimonialsMarquee />
    </section>
  )
}
